import React from "react";
import StronaGlowna from "../components/StronaGlowna";

export default function Home(){
    return(
        <div>
            <StronaGlowna/>
        </div>
    );
}